// extracted by mini-css-extract-plugin
module.exports = {"dot":"_30g-oAoL0awa7TqUniXQyp"};